import { RouteLocationNormalizedLoaded, RouteRecordRaw } from 'vue-router';
import Layout from '@/components/layout/index.vue';
import Welcome from '@/pages/welcome/index.vue';
import Login from '@/pages/login/index.vue';
import { useLayoutStore } from '@/store';

function getProps(route: RouteLocationNormalizedLoaded) {
  return route.query;
}

// 系统生成路由
export const routers: Array<RouteRecordRaw> = [
  {
    path: '/login',
    component: Login,
    name: 'login',
    meta: {
      title: '登录',
    },
  },
  {
    path: '/',
    component: Layout,
    name: 'main',
    props: getProps,
    redirect: {
      name: 'welcome',
    },
    meta: {
      title: '主页',
      showOnly: true,
    },
    children: [
      {
        path: 'welcome',
        component: Welcome,
        name: 'welcome',
        meta: { title: '欢迎', keepalive: false },
      },
      {
        path: 'wkcWeeklySchedule',
        component: () => import('@/pages/workflow/wkcWeeklySchedule/wkcWeeklySchedule.vue'),
        name: 'wkcWeeklySchedule',
        props: getProps,
        meta: { title: '一周安排', keepalive: false },
      },
      {
        path: 'workArrangement',
        component: () => import('@/pages/welcome/workArrangement.vue'),
        name: 'workArrangement',
        props: getProps,
        meta: { title: '工作安排', keepalive: false },
      },
      {
        path: 'wkcDocumentMessage',
        component: () => import('@/pages/workflow/wkcDocumentMessage/wkcDocumentMessage.vue'),
        name: 'wkcDocumentMessage',
        props: getProps,
        meta: { title: '文档抄送', keepalive: false },
      },
      {
        path: 'dutyScheduleMessage',
        component: () => import('@/pages/workflow/pages/dutySchedule/dutyScheduleMessage.vue'),
        name: 'dutyScheduleMessage',
        props: getProps,
        meta: { title: '值班计划', keepalive: true }
      },
      {
        path: 'occupierMessage',
        component: () => import('@/pages/workflow/pages/userCar/occupierMessage.vue'),
        name: 'occupierMessage',
        props: getProps,
        meta: { title: '车辆占用信息', keepalive: false },
      },
      {
        path: 'WkcAssetAcquisition',
        component: () => import('@/pages/workflow/pages/wkcAssetAcquisition/wkcAssetAcquisition.vue'),
        name: 'WkcAssetAcquisition',
        props: getProps,
        meta: {title: '资产领用工单列表', keepalive: true}
      },
      {
        path: 'summaryListDetail',
        component: () => import('@/pages/workflow/attendanceReport/summaryListDetail.vue'),
        name: 'summaryListDetail',
        props: getProps,
        meta: { title: '报表明细', keepalive: false },
      },
      {
        path: 'purchaseStorage',
        component: () => import('@/pages/workflow/pages/applyBuy/purchaseStorage.vue'),
        name: 'purchaseStorage',
        props: getProps,
        meta: { title: '采购入库', keepalive: false },
      },
      {
        path: 'ListOfAssets',
        component: () => import('@/pages/generated/listOfAssets.vue'),
        name: 'ListOfAssets',
        props: getProps,
        meta: {title: '资产列表', keepalive: true}
      },

      {
        path: 'formSysMenu',
        component: () =>
          useLayoutStore().supportColumn
            ? import('@/pages/upms/formSysMenu/formSysColumnMenu.vue')
            : import('@/pages/upms/formSysMenu/index.vue'),
        name: 'formSysMenu',
        meta: { title: '菜单列表', keepalive: true },
      },
      {
        path: 'formSysUser',
        component: () => import('@/pages/upms/formSysUser/index.vue'),
        name: 'formSysUser',
        meta: { title: '用户列表', keepalive: true },
      },
      {
        path: 'formSysDept',
        component: () => import('@/pages/upms/formSysDept/index.vue'),
        name: 'formSysDept',
        meta: { title: '部门列表', keepalive: true },
      },
      {
        path: 'formSysRole',
        component: () => import('@/pages/upms/formSysRole/index.vue'),
        name: 'formSysRole',
        meta: { title: '角色管理', keepalive: true },
      },
      {
        path: 'formSysDataPerm',
        component: () => import('@/pages/upms/formSysDataPerm/index.vue'),
        name: 'formSysDataPerm',
        meta: { title: '数据权限管理', keepalive: true },
      },
      {
        path: 'formSysLoginUser',
        component: () => import('@/pages/upms/formSysLoginUser/index.vue'),
        name: 'formSysLoginUser',
        meta: { title: '在线用户', keepalive: true },
      },
      // 岗位模块路由配置
      {
        path: 'formSysPost',
        component: () => import('@/pages/upms/formSysPost/index.vue'),
        name: 'formSysPost',
        meta: { title: '岗位管理', keepalive: true },
      },
      {
        path: 'formSysDeptPost',
        component: () => import('@/pages/upms/formSysDeptPost/index.vue'),
        name: 'formSysDeptPost',
        props: getProps,
        meta: { title: '设置部门岗位', keepalive: true },
      },
      {
        path: 'formSysDict',
        component: () => import('@/pages/upms/formSysDict/index.vue'),
        name: 'formSysDict',
        meta: { title: '字典管理', keepalive: true },
      },
      {
        path: 'formSysOperationLog',
        component: () => import('@/pages/upms/formSysOperationLog/index.vue'),
        name: 'formSysOperationLog',
        meta: { title: '操作日志', keepalive: true },
      },
      // 404
      {
        path: '/:pathMatch(.*)*',
        component: () => import('@/pages/error/404.vue'),
        name: 'NotFound',
        meta: {
          title: '404',
        },
      },
      // 在线表单
      {
        path: 'formOnlineDblink',
        component: () => import('@/pages/online/formOnlineDblink/index.vue'),
        name: 'formOnlineDblink',
        props: getProps,
        meta: { title: '数据库链接', keepalive: true },
      },
      {
        path: 'formOnlineDict',
        component: () => import('@/pages/online/formOnlineDict/index.vue'),
        name: 'formOnlineDict',
        props: getProps,
        meta: { title: '在线表单字典管理', keepalive: true },
      },
      {
        path: 'formOnlinePage',
        component: () => import('@/pages/online/formOnlinePage/index.vue'),
        name: 'formOnlinePage',
        props: getProps,
        meta: { title: '在线表单管理', keepalive: true },
      },
      {
        path: 'onlineForm',
        component: () => import('@/pages/online/OnlinePageRender/index.vue'),
        name: 'onlineForm',
        props: getProps,
        meta: { title: '在线表单', keepalive: true },
      },
      // 工作流模块
      {
        path: 'formMessage',
        component: () => import('@/pages/workflow/formMessage/index.vue'),
        name: 'formMessage',
        props: getProps,
        meta: { title: '催办消息', keepalive: true },
      },
      {
        path: 'noticeList',
        component: () => import('@/pages/welcome/noticeList.vue'),
        name: 'noticeList',
        props: getProps,
        meta: { title: '通知信息', keepalive: true },
      },
      {
        path: 'formFlowCategory',
        component: () => import('@/pages/workflow/flowCategory/formFlowCategory.vue'),
        name: 'formFlowCategory',
        props: getProps,
        meta: { title: '流程分类管理', keepalive: true },
      },
      {
        path: 'formFlowEntry',
        component: () => import('@/pages/workflow/flowEntry/formFlowEntry.vue'),
        name: 'formFlowEntry',
        props: getProps,
        meta: { title: '流程设计', keepalive: true },
      },
      {
        path: 'formFlowAssigneeBatch',
        component: () => import('@/pages/workflow/flowEntry/formFlowAssigneeBatch.vue'),
        name: 'formFlowAssigneeBatch',
        props: getProps,
        meta: { title: '审批人批量配置', keepalive: true },
      },
      {
        path: 'formFlowDblink',
        component: () => import('@/pages/workflow/formFlowDblink/index.vue'),
        name: 'formFlowDblink',
        props: getProps,
        meta: { title: '流程数据库链接', keepalive: true },
      },
      {
        path: 'formAllInstance',
        component: () => import('@/pages/workflow/taskManager/formAllInstance.vue'),
        name: 'formAllInstance',
        props: getProps,
        meta: { title: '流程实例', keepalive: true },
      },
       {
        path: 'idcard01',
        component: () => import('@/pages/generated/idcard01.vue'),
        name: 'idcard01',
        props: getProps,
        meta: {title: '证件管理填写', keepalive: true}
      },
      {
        path: 'idcard010',
        component: () => import('@/pages/generated/idcard010.vue'),
        name: 'idcard010',
        props: getProps,
        meta: {title: '证件管理编辑', keepalive: true}
      },
      {
        path: 'idcard020',
        component: () => import('@/pages/generated/idcard020.vue'),
        name: 'idcard020',
        props: getProps,
        meta: {title: '证件管理详情', keepalive: true}
      },
      {
        path: 'handlerFlowTask',
        component: () => import('@/pages/workflow/handlerFlowTask/index.vue'),
        name: 'handlerFlowTask',
        props: getProps,
        meta: { title: '流程处理' },
        children: [
          // 静态表单路由设置
          {
            path: 'formLeaveRoute',
            component: () => import('@/pages/workflow/pages/flowLeave/formLeaveRoute.vue'),
            name: 'formLeaveRoute',
            props: getProps,
            meta: { title: '请假申请', keepalive: true }
          },
          {
            path: 'flowOvertime',
            component: () => import('@/pages/workflow/pages/flowOvertime/flowOvertime.vue'),
            name: 'flowOvertime',
            props: getProps,
            meta: { title: '加班申请', keepalive: true }
          },
          {
            path: 'formTimeOffRoute',
            component: () => import('@/pages/workflow/pages/flowTimeOff/formTimeOffRoute.vue'),
            name: 'formTimeOffRoute',
            props: getProps,
            meta: { title: '调休申请', keepalive: true }
          },
          {
            path: 'flowMeetingRequest',
            component: () => import('@/pages/workflow/pages/flowMeetingRequest/flowMeetingRequest.vue'),
            name: 'flowMeetingRequest',
            props: getProps,
            meta: { title: '会议申请(路由)', keepalive: true }
          },
          {
            path: 'formBusinessTripRoute',
            component: () => import('@/pages/workflow/pages/flowBusinessTrip/formBusinessTripRoute.vue'),
            name: 'formBusinessTripRoute',
            props: getProps,
            meta: { title: '出差申请', keepalive: true }
          },
          {
            path: 'UserCar01',
            component: () => import('@/pages/workflow/pages/userCar/userCar01.vue'),
            name: 'UserCar01',
            props: getProps,
            meta: { title: '用车填写', keepalive: true }
          },
          {
            path: 'useSeal01',
            component: () => import('@/pages/workflow/pages/useSeal/useSeal01.vue'),
            name: 'useSeal01',
            props: getProps,
            meta: { title: '用印填写', keepalive: true }
          },
          {
            path: 'applyBuy01',
            component: () => import('@/pages/workflow/pages/applyBuy/applyBuy01.vue'),
            name: 'applyBuy01',
            props: getProps,
            meta: { title: '采购填写', keepalive: true }
          },
          {
            path: 'applyBuyInfo',
            component: () => import('@/pages/workflow/pages/applyBuy/applyBuyInfo.vue'),
            name: 'applyBuyInfo',
            props: getProps,
            meta: { title: '采购详情编辑', keepalive: true }
          },
          {
            path: 'WkcAssetAcquisitionDetail',
            component: () => import('@/pages/workflow/pages/wkcAssetAcquisition/wkcAssetAcquisitionDetail.vue'),
            name: 'WkcAssetAcquisitionDetail',
            props: getProps,
            meta: {title: '资产领用明细', keepalive: true}
          },
          {
            path: 'wkcAssetRestitutionDetail',
            component: () => import('@/pages/workflow/pages/wkcAssetRestitution/wkcAssetRestitutionDetail.vue'),
            name: 'wkcAssetRestitutionDetail',
            props: getProps,
            meta: {title: '资产归还明细', keepalive: false}
          },
          {
            path: 'notice01',
            component: () => import('@/pages/workflow/pages/notice/notice01.vue'),
            name: 'notice01',
            props: getProps,
            meta: {title: '通知公告填写', keepalive: true}
          },
          {
            path: 'PurchaseApplicationDetails',
            component: () => import('@/pages/workflow/pages/wkcPurchaseApplication/purchaseApplicationDetails.vue'),
            name: 'PurchaseApplicationDetails',
            props: getProps,
            meta: {title: '采购申购明细', keepalive: false}
          },
          {
            path: 'FlowPrivateExitRecords',
            component: () => import('@/pages/workflow/pages/flowPrivateExitRecords/flowPrivateExitRecords.vue'),
            name: 'FlowPrivateExitRecords',
            props: getProps,
            meta: {title: '因私出境流程', keepalive: false}
          },
          {
            path: 'ConfidentialityEducationDialog',
            component: () => import('@/pages/generated/ConfidentialityEducationDialog.vue'),
            name: 'ConfidentialityEducationDialog',
            props: getProps,
            meta: {title: '因私出国保密纪律教育要点', keepalive: false}
          },
          {
            path: 'flowRetentionPartyMembership',
            component: () => import('@/pages/workflow/pages/flowRetentionPartyMembership/flowRetentionPartyMembership.vue'),
            name: 'flowRetentionPartyMembership',
            props: getProps,
            meta: {title: '党籍保留流程', keepalive: false}
          },
          {
            path: 'flowRetentionPartyMembershipFast',
            component: () => import('@/pages/generated/flowRetentionPartyMembershipFast.vue'),
            name: 'flowRetentionPartyMembershipFast',
            props: getProps,
            meta: {title: '党籍保留快捷页面', keepalive: true}
          },
          {
            path: 'FlowsContractAnagement',
            component: () => import('@/pages/workflow/pages/flowContract/flowsContractAnagement.vue'),
            name: 'FlowsContractAnagement',
            props: getProps,
            meta: {title: '合同审批流程', keepalive: false}
          },
          {
            path: 'lawyerContractView',
            component: () => import('@/pages/workflow/pages/flowContract/lawyerContractView.vue'),
            name: 'lawyerContractView',
            props: getProps,
            meta: { title: '合同律师查看', keepalive: false },
          },
           {
            path: 'send01',
            component: () => import('@/pages/workflow/pages/send/send01.vue'),
            name: 'send01',
            props: getProps,
            meta: {title: '发文审批填写', keepalive: false}
          },
          {
            path: 'flowPublicServiceReception',
            component: () => import('@/pages/workflow/pages/publicServiceReception/flowPublicServiceReception.vue'),
            name: 'flowPublicServiceReception',
            props: getProps,
            meta: {title: '公务接待流程', keepalive: false}
          },
          {
            path: 'officialaccount01',
            component: () => import('@/pages/workflow/pages/officialaccount/officialaccount01.vue'),
            name: 'officialaccount01',
            props: getProps,
            meta: {title: '公众号审批填写', keepalive: false}
          },
          {
            path: 'newofficialaccount',
            component: () => import('@/pages/workflow/pages/newofficialaccount/newofficialaccount.vue'),
            name: 'newofficialaccount',
            props: getProps,
            meta: {title: '公众号审批填写-试用', keepalive: false}
          },
           { // 周报计划
            path: 'flowWeeklyScheduleDetail',
            component: () => import('@/pages/workflow/pages/weekPlan/flowWeeklyScheduleDetail.vue'),
            name: 'flowWeeklyScheduleDetail',
            props: getProps,
            meta: {title: '一周安排流程', keepalive: false}
          },
        ],
      },
      {
        path: 'formMyTask',
        component: () => import('@/pages/workflow/taskManager/formMyTask.vue'),
        name: 'formMyTask',
        props: getProps,
        meta: { title: '待办事宜', keepalive: true },
      },
      {
        path: 'formMyApprovedTask',
        component: () => import('@/pages/workflow/taskManager/formMyApprovedTask.vue'),
        name: 'formMyApprovedTask',
        props: getProps,
        meta: { title: '已办任务', keepalive: true },
      },

      {
        path: 'CcMessageList',
        component: () => import('@/pages/welcome/ccMessageList.vue'),
        name: 'CcMessageList',
        props: getProps,
        meta: { title: '抄送信息', keepalive: true },
      },
      {
        path: 'formMyHistoryTask',
        component: () => import('@/pages/workflow/taskManager/formMyHistoryTask.vue'),
        name: 'formMyHistoryTask',
        props: getProps,
        meta: { title: '历史流程', keepalive: true },
      },
      // 移动端管理
      {
        path: 'formSudoku',
        component: () => import('@/pages/mobile/formMobileEntry/formSudoku.vue'),
        name: 'formSudoku',
        props: {
          entryType: 1,
        },
        meta: { title: '九宫格配置', keepalive: true },
      },
      {
        path: 'formBanner',
        component: () => import('@/pages/mobile/formMobileEntry/formBanner.vue'),
        name: 'formBanner',
        props: {
          entryType: 0,
        },
        meta: { title: '轮播图配置配置', keepalive: true },
      },
      // 报表路由
      {
        path: 'reportRender',
        component: () => import('@/pages/report/formReportPage/reportRender/index.vue'),
        name: 'reportRender',
        props: getProps,
        meta: { title: '报表', keepalive: true },
      },
      {
        path: 'formReportDblink',
        component: () => import('@/pages/report/formReportDblink/index.vue'),
        name: 'formReportDblink',
        meta: { title: '报表数据源', keepalive: true },
      },
      {
        path: 'formReportDataset',
        component: () => import('@/pages/report/formReportDataset/index.vue'),
        name: 'formReportDataset',
        meta: { title: '报表数据集', keepalive: true },
      },
      {
        path: 'formReportDict',
        component: () => import('@/pages/report/formReportDict/index.vue'),
        name: 'formReportDict',
        meta: { title: '报表字典', keepalive: true },
      },
      {
        path: 'formReportPage',
        component: () => import('@/pages/report/formReportPage/index.vue'),
        name: 'formReportPage',
        meta: { title: '报表页面', keepalive: true },
      },
      {
        path: 'formPrintManage',
        component: () => import('@/pages/report/formPrint/index.vue'),
        name: 'formPrintManage',
        meta: { title: '打印管理', keepalive: true },
      },
      {
        path: 'formDocument',
        component: () => import('@/pages/WkcDocument/formDocument.vue'),
        name: 'formDocument',
        props: getProps,
        meta: {title: '文档', keepalive: true}
      },
      {
        path: 'formEditDocument',
        component: () => import('@/pages/WkcDocument/formEditDocument.vue'),
        name: 'formEditDocument',
        props: getProps,
        meta: {title: '编辑文件', keepalive: true}
      },
      {
        path: 'formLeaveRouteOrder',
        component: () => import('@/pages/workflow/pages/flowLeave/formLeaveRouteOrder.vue'),
        name: 'formLeaveRouteOrder',
        props: getProps,
        meta: { title: '请假工单', keepalive: true }
      },
      {
        path: 'flowOvertimeOrder',
        component: () => import('@/pages/workflow/pages/flowOvertime/flowOvertimeOrder.vue'),
        name: 'flowOvertimeOrder',
        props: getProps,
        meta: { title: '加班工单', keepalive: true }
      },
      {
        path: 'formTimeOffRouteOrder',
        component: () => import('@/pages/workflow/pages/flowTimeOff/formTimeOffRouteOrder.vue'),
        name: 'formTimeOffRouteOrder',
        props: getProps,
        meta: { title: '调休工单', keepalive: true }
      },
      {
        path: 'flowMeetingRequestOrder',
        component: () => import('@/pages/workflow/pages/flowMeetingRequest/flowMeetingRequestOrder.vue'),
        name: 'flowMeetingRequestOrder',
        props: getProps,
        meta: { title: '会议申请', keepalive: true }
      },
      {
        path: 'formBusinessTripRouteOrder',
        component: () => import('@/pages/workflow/pages/flowBusinessTrip/formBusinessTripRouteOrder.vue'),
        name: 'formBusinessTripRouteOrder',
        props: getProps,
        meta: { title: '出差工单', keepalive: true }
      },
      {
        path: 'formBusinessTripPrint',
        component: () => import('@/pages/workflow/pages/flowBusinessTrip/businessTripPrint.vue'),
        name: 'formBusinessTripPrint',
        props: getProps,
        meta: { title: '出差申请表打印', keepalive: false }
      },
      {
        path: 'businessTripDetailReport',
        component: () => import('@/pages/workflow/pages/flowBusinessTrip/businessTripDetailReport.vue'),
        name: 'businessTripDetailReport',
        props: getProps,
        meta: { title: '出差申请明细报表', keepalive: true }
      },
      {
        path: 'weekPlan',
        component: () => import('@/pages/workflow/pages/weekPlan/weekPlanList.vue'),
        name: 'weekPlan',
        props: getProps,
        meta: { title: '一周安排列表', keepalive: true }
      },
      {
        path: 'dutySchedule',
        component: () => import('@/pages/workflow/pages/dutySchedule/dutyScheduleList.vue'),
        name: 'dutySchedule',
        props: getProps,
        meta: { title: '值班计划列表', keepalive: true }
      },
      {
        path: 'attendanceReport',
        component: () => import('@/pages/workflow/attendanceReport/summaryList.vue'),
        name: 'attendanceReport',
        props: getProps,
        meta: { title: '考勤汇总报表', keepalive: true },
      },

      {
        path: 'summaryDetailList',
        component: () => import('@/pages/workflow/attendanceReport/summaryDetailList.vue'),
        name: 'summaryDetailList',
        props: getProps,
        meta: { title: '考勤明细报表', keepalive: true },
      },

      {
        path: 'leaveStatement',
        component: () => import('@/pages/generated/leaveStatement.vue'),
        name: 'leaveStatement',
        props: getProps,
        meta: { title: '请假申请报表', keepalive: true }
      },
      {
        path: 'repairStatement',
        component: () => import('@/pages/generated/repairStatement.vue'),
        name: 'repairStatement',
        props: getProps,
        meta: { title: '调休申请报表', keepalive: true }
      },
      {
        path: 'UserCar',
        component: () => import('@/pages/car/userCar.vue'),
        name: 'UserCar',
        props: getProps,
        meta: { title: '用车查询', keepalive: true }
      },
      {
        path: 'userCarRouteOrder',
        component: () => import('@/pages/workflow/pages/userCar/userCarRouteOrder.vue'),
        name: 'userCarRouteOrder',
        props: getProps,
        meta: { title: '用车展示', keepalive: true }
      },
      {
        path: 'userCarBaoBiao',
        component: () => import('@/pages/generated/userCarBaoBiao.vue'),
        name: 'userCarBaoBiao',
        props: getProps,
        meta: {title: '用车申请报表', keepalive: true}
      },
      {
        path: 'useSealRouteOrder',
        component: () => import('@/pages/workflow/pages/useSeal/useSealRouteOrder.vue'),
        name: 'useSealRouteOrder',
        props: getProps,
        meta: { title: '用印展示', keepalive: true }
      },
      {
        path: 'useSeal',
        component: () => import('@/pages/generated/useSeal.vue'),
        name: 'useSeal',
        props: getProps,
        meta: { title: '用印查询', keepalive: true }
      },
      {
        path: 'applyBuy',
        component: () => import('@/pages/generated/applyBuy.vue'),
        name: 'applyBuy',
        props: getProps,
        meta: { title: '采购查询', keepalive: true }
      },
      {
        path: 'applyBuyRouteOrder',
        component: () => import('@/pages/workflow/pages/applyBuy/applyBuyRouteOrder.vue'),
        name: 'applyBuyRouteOrder',
        props: getProps,
        meta: { title: '采购展示', keepalive: true }
      },
      {
        path: 'applyBuyDetailReport',
        component: () => import('@/pages/workflow/pages/applyBuy/applyBuyDetailReport.vue'),
        name: 'applyBuyDetailReport',
        props: getProps,
        meta: { title: '采购计划明细报表', keepalive: true }
      },

      {
        path: 'formOvertimeRecord',
        component: () => import('@/pages/generated/formOvertimeRecord.vue'),
        name: 'formOvertimeRecord',
        props: getProps,
        meta: { title: '加班记录', keepalive: true }
      },
      {
        path: 'HolidaySetting',
        component: () => import('@/pages/holidayDistributes/holidaySetting.vue'),
        name: 'HolidaySetting',
        props: getProps,
        meta: {title: '假期设置', keepalive: true}
      },
      {
        path: 'holidaySettings',
        component: () => import('@/pages/HolidaySetting/holidaySettings.vue'),
        name: 'holidaySettings',
        props: getProps,
        meta: {title: '节假日设置', keepalive: true}
      },
      {
        path: 'leaveConfig',
        component: () => import('@/pages/generated/leaveConfig.vue'),
        name: 'leaveConfig',
        props: getProps,
        meta: {title: '请假配置', keepalive: true}
      },
      // {
      //   path: 'formOvertimeRecord',
      //   component: () => import('@/pages/generated/formOvertimeRecord.vue'),
      //   name: 'formOvertimeRecord',
      //   props: getProps,
      //   meta: { title: '加班记录', keepalive: true }
      // },
      {
        path: 'noticeRouteOrder',
        component: () => import('@/pages/workflow/pages/notice/noticeRouteOrder.vue'),
        name: 'noticeRouteOrder',
        props: getProps,
        meta: {title: '通知公告展示', keepalive: true}
      },
      {
        path: 'wkcAssetAcquisitionSummarylList',
        component: () => import('@/pages/generated/wkcAssetAcquisitionSummarylList.vue'),
        name: 'wkcAssetAcquisitionSummarylList',
        props: getProps,
        meta: {title: '资产领用汇总列表', keepalive: true}
      },
       {
        path: 'wkcAssetAcquisitionDetailList',
        component: () => import('@/pages/generated/wkcAssetAcquisitionDetailList.vue'),
        name: 'wkcAssetAcquisitionDetailList',
        props: getProps,
        meta: {title: '资产领用明细列表', keepalive: true}
      },
       {
        path: 'wkcAssetAcquisitionDetailEvaluationList',
        component: () => import('@/pages/generated/wkcAssetAcquisitionDetailEvaluationList.vue'),
        name: 'wkcAssetAcquisitionDetailEvaluationList',
        props: getProps,
        meta: {title: '资产领用评价列表', keepalive: true}
      },

      {
        path: 'wkcAssetRestitution',
        component: () => import('@/pages/workflow/pages/wkcAssetRestitution/wkcAssetRestitution.vue'),
        name: 'wkcAssetRestitution',
        props: getProps,
        meta: {title: '资产归还', keepalive: true}
      },
      {
        path: 'PurchaseApplicationHeader',
        component: () => import('@/pages/workflow/pages/wkcPurchaseApplication/purchaseApplicationHeader.vue'),
        name: 'PurchaseApplicationHeader',
        props: getProps,
        meta: {title: '申购单列表', keepalive: true}
      },
      {
        path: 'purchaseApplicationDateilList',
        component: () => import('@/pages/generated/purchaseApplicationDateilList.vue'),
        name: 'purchaseApplicationDateilList',
        props: getProps,
        meta: {title: '采购申购明细', keepalive: true}
      },

      {
        path: 'PrivateExitRecords',
        component: () => import('@/pages/workflow/pages/flowPrivateExitRecords/privateExitRecords.vue'),
        name: 'PrivateExitRecords',
        props: getProps,
        meta: {title: '因私出境', keepalive: true}
      },
      {
        path: 'PrivateExitRecordsPersonnel',
        component: () => import('@/pages/generated/privateExitRecordsPersonnel.vue'),
        name: 'PrivateExitRecordsPersonnel',
        props: getProps,
        meta: {title: '因私出境(人事)', keepalive: true}
      },

      {
        path: 'PrivateExitRecordsPersonnelDetails',
        component: () => import('@/pages/generated/privateExitRecordsPersonnelDetails.vue'),
        name: 'PrivateExitRecordsPersonnelDetails',
        props: getProps,
        meta: {title: '因私出境详情(人事)', keepalive: true}
      },
      {
        path: 'RetentionPartyMembershipOrder',
        component: () => import('@/pages/workflow/pages/flowRetentionPartyMembership/retentionPartyMembershipOrder.vue'),
        name: 'RetentionPartyMembershipOrder',
        props: getProps,
        meta: {title: '党籍保留工单', keepalive: true}
      },
      {
        path: 'ContractAnagementFlow',
        component: () => import('@/pages/workflow/pages/flowContract/contractAnagementFlow.vue'),
        name: 'ContractAnagementFlow',
        props: getProps,
        meta: {title: '合同审批工单', keepalive: true}
      },
      {
        path: 'formDutyDetails',
        component: () => import('@/pages/generated/formDutyDetails.vue'),
        name: 'formDutyDetails',
        props: getProps,
        meta: {title: '值班明细', keepalive: true}
      },
      {
        path: 'summaryAnnualLeave',
        component: () => import('@/pages/generated/summaryAnnualLeave.vue'),
        name: 'summaryAnnualLeave',
        props: getProps,
        meta: {title: '年休假汇总表', keepalive: true}
      },
      {
        path: 'summaryTimeOff',
        component: () => import('@/pages/generated/summaryTimeOff.vue'),
        name: 'summaryTimeOff',
        props: getProps,
        meta: {title: '调休假汇总表', keepalive: true}
      },
      {
        path: 'summaryTimeOffDetails',
        component: () => import('@/pages/generated/summaryTimeOffDetails.vue'),
        name: 'summaryTimeOffDetails',
        props: getProps,
        meta: {title: '假期明细', keepalive: true}
      },
      {
        path: 'summaryDuty',
        component: () => import('@/pages/generated/summaryDuty.vue'),
        name: 'summaryDuty',
        props: getProps,
        meta: {title: '值班汇总表(旧)', keepalive: true}
      },
      {
        path: 'summaryDutyNew',
        component: () => import('@/pages/generated/summaryDutyNew.vue'),
        name: 'summaryDutyNew',
        props: getProps,
        meta: {title: '值班汇总表', keepalive: true}
      },
      {
        path: 'summaryDutyByCreateUser',
        component: () => import('@/pages/generated/summaryDutyByCreateUser.vue'),
        name: 'summaryDutyByCreateUser',
        props: getProps,
        meta: {title: '值班分配', keepalive: true}
      },
      {
        path: 'summaryDutyDetail',
        component: () => import('@/pages/generated/summaryDutyDetail.vue'),
        name: 'summaryDutyDetail',
        props: getProps,
        meta: {title: '值班明细', keepalive: true}
      },
      {
        path: 'sendRouteOrder',
        component: () => import('@/pages/workflow/pages/send/sendRouteOrder.vue'),
        name: 'sendRouteOrder',
        props: getProps,
        meta: {title: '发文审批展示', keepalive: true}
      },
      {
        path: 'publicServiceReception',
        component: () => import('@/pages/workflow/pages/publicServiceReception/publicServiceReception.vue'),
        name: 'publicServiceReception',
        props: getProps,
        meta: {title: '公务接待工单列表', keepalive: true}
      },
      {
        path: 'officialaccountRouteOrder',
        component: () => import('@/pages/workflow/pages/officialaccount/officialaccountRouteOrder.vue'),
        name: 'officialaccountRouteOrder',
        props: getProps,
        meta: {title: '公众号审批展示', keepalive: true}
      },
       {
        path: 'newofficialaccountRouteOrder',
        component: () => import('@/pages/workflow/pages/newofficialaccount/newofficialaccountRouteOrder.vue'),
        name: 'newofficialaccountRouteOrder',
        props: getProps,
        meta: {title: '公众号审批-试用', keepalive: true}
      },
       {
        path: 'wkcWeeklyScheduleOrder',
        component: () => import('@/pages/workflow/pages/weekPlan/wkcWeeklyScheduleOrder.vue'),
        name: 'wkcWeeklyScheduleOrder',
        props: getProps,
        meta: {title: '一周安排工单', keepalive: true}
      },
      {
        path: 'idcardRouteOrder',
        component: () => import('@/pages/generated/idcardRouteOrder.vue'),
        name: 'idcardRouteOrder',
        props: getProps,
        meta: {title: '证件管理展示', keepalive: true}
      },
      {
        path: 'idCardBaoBiao',
        component: () => import('@/pages/generated/idCardBaoBiao.vue'),
        name: 'idCardBaoBiao',
        props: getProps,
        meta: {title: '证件报表', keepalive: true}
      },
      {
        path: 'personalAssetAlocationHead',
        component: () => import('@/pages/generated/personalAssetAlocationHead.vue'),
        name: 'personalAssetAlocationHead',
        props: getProps,
        meta: {title: '个人资产配置列表', keepalive: true}
      },
      {
        path: 'personalAssetAllocationDetail',
        component: () => import('@/pages/generated/personalAssetAllocationDetail.vue'),
        name: 'personalAssetAllocationDetail',
        props: getProps,
        meta: {title: '个人资产配置明细', keepalive: true}
      },
      {
        path: 'sysConfiguration',
        component: () => import('@/pages/generated/sysConfiguration.vue'),
        name: 'sysConfiguration',
        props: getProps,
        meta: {title: '基础配置', keepalive: true}
      },
      {
        path: 'ReservationAreaList',
        component: () => import('@/pages/generated/reservationAreaList.vue'),
        name: 'ReservationAreaList',
        props: getProps,
        meta: {title: '预约区域管理列表', keepalive: true}
      },
      {
        path: 'DailyAppointmentList',
        component: () => import('@/pages/generated/dailyAppointmentList.vue'),
        name: 'DailyAppointmentList',
        props: getProps,
        meta: {title: '日常预约管理列表', keepalive: true}
      },
       {
        path: 'DailyAppointmentInformationList',
        component: () => import('@/pages/generated/dailyAppointmentInformationList.vue'),
        name: 'DailyAppointmentInformationList',
        props: getProps,
        meta: {title: '预约活动信息列表', keepalive: true}
      },
       {
        path: 'SchedulingConfigurationList',
        component: () => import('@/pages/generated/schedulingConfigurationList.vue'),
        name: 'SchedulingConfigurationList',
        props: getProps,
        meta: {title: '排期配置列表', keepalive: true}
      },
      {
        path: 'wxPersonnelReservationRecord',
        component: () => import('@/pages/generated/wxPersonnelReservationRecord.vue'),
        name: 'wxPersonnelReservationRecord',
        props: getProps,
        meta: {title: '人员预约记录', keepalive: true}
      },
      {
        path: 'WxReservationBlacklistTable',
        component: () => import('@/pages/generated/wxReservationBlacklistTable.vue'),
        name: 'WxReservationBlacklistTable',
        props: getProps,
        meta: {title: '预约黑名单管理', keepalive: true}
      },
      {
        path: 'WxAppointmentUserInfo',
        component: () => import('@/pages/generated/wxAppointmentUserInfo.vue'),
        name: 'WxAppointmentUserInfo',
        props: getProps,
        meta: {title: '微信预约用户信息', keepalive: true}
      },
    ],
  },
  // TODO 第三方接入路由
  {
    path: '/thirdParty',
    component: () => import('@/components/thirdParty/index.vue'),
    name: 'thirdParty',
    props: getProps,
    children: [
      // 流程分类列表
      {
        path: 'thirdFormFlowCategory',
        name: 'thirdFormFlowCategory',
        props: getProps,
        component: () => import('@/pages/workflow/flowCategory/formFlowCategory.vue'),
      },
      // 流程分类 新增、编辑
      {
        path: 'thirdAddFormFlowCategory',
        name: 'thirdAddFormFlowCategory',
        props: getProps,
        component: () => import('@/pages/workflow/flowCategory/formEditFlowCategory.vue'),
      },
      // 流程实例列表
      {
        path: 'thirdFormAllInstance',
        name: 'thirdFormAllInstance',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/formAllInstance.vue'),
      },
      // 流程图
      {
        path: 'thirdFormTaskProcessViewer',
        name: 'thirdFormTaskProcessViewer',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/formTaskProcessViewer.vue'),
      },
      // 流程干涉
      {
        path: 'thirdFormInterposeInstance',
        name: 'thirdFormInterposeInstance',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/formInterposeInstance.vue'),
      },
      // 流程复活
      {
        path: 'thirdFormRestartInstance',
        name: 'thirdFormRestartInstance',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/formRestart.vue'),
      },
      // 数据补偿
      {
        path: 'thirdFormCompensationInstance',
        name: 'thirdFormCompensationInstance',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/processCompensation.vue'),
      },
      // 流程终止
      {
        path: 'thirdFormStopTaskInstance',
        name: 'thirdFormStopTaskInstance',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/stopTask.vue'),
      },
      // 选择用户-处理用户
      {
        path: 'thirdTaskUserSelect',
        name: 'thirdTaskUserSelect',
        props: getProps,
        component: () => import('@/pages/workflow/components/TaskUserSelect.vue'),
      },
      // 选择用户-跳转节点
      {
        path: 'thirdSelectUserTask',
        name: 'thirdSelectUserTask',
        props: getProps,
        component: () => import('@/pages/workflow/components/UserTaskSelect/userTaskSelectDlg.vue'),
      },
      // 流程设计
      {
        path: 'thirdFlowDblink',
        name: 'thirdFlowDblink',
        props: getProps,
        component: () => import('@/pages/workflow/formFlowDblink/index.vue'),
      },
      {
        path: 'thirdEditFlowDblink',
        name: 'thirdEditFlowDblink',
        props: getProps,
        component: () => import('@/pages/workflow/formFlowDblink/editFlowDblink.vue'),
      },
      {
        path: 'thirdFormFlowEntry',
        name: 'thirdFormFlowEntry',
        props: getProps,
        component: () => import('@/pages/workflow/flowEntry/formFlowEntry.vue'),
      },
      {
        path: 'thirdFormFlowAssigneeBatch',
        name: 'thirdFormFlowAssigneeBatch',
        props: getProps,
        component: () => import('@/pages/workflow/flowEntry/formFlowAssigneeBatch.vue'),
      },
      {
        path: 'thirdFormEditFlowEntry',
        name: 'thirdFormEditFlowEntry',
        props: getProps,
        component: () => import('@/pages/workflow/flowEntry/formEditFlowEntry.vue'),
      },
      {
        path: 'thirdFormPublishedFlowEntry',
        name: 'thirdFormPublishedFlowEntry',
        props: getProps,
        component: () => import('@/pages/workflow/flowEntry/formPublishedFlowEntry.vue'),
      },
      {
        path: 'thirdHandlerFlowTask',
        name: 'thirdHandlerFlowTask',
        props: getProps,
        component: () => import('@/pages/workflow/handlerFlowTask/index.vue'),
      },
      // 流程设计-候选用户组
      {
        path: 'thirdTaskGroupSelect',
        name: 'thirdTaskGroupSelect',
        props: getProps,
        component: () => import('@/pages/workflow/components/TaskGroupSelect.vue'),
      },
      // 流程设计-选择岗位
      {
        path: 'thirdTaskPostSelect',
        name: 'thirdTaskPostSelect',
        props: getProps,
        component: () => import('@/pages/workflow/components/TaskPostSelect.vue'),
      },
      // 流程设计-抄送
      {
        path: 'thirdAddCopyForItem',
        name: 'thirdAddCopyForItem',
        props: getProps,
        component: () => import('@/pages/workflow/components/CopyForSelect/addCopyForItem.vue'),
      },
      // 自定义-抄送
      {
        path: 'thirdAddCustomCopyForItem',
        name: 'thirdAddCustomCopyForItem',
        props: getProps,
        component: () => import('@/pages/workflow/components/CustomCopyForSelect/addCopyForItem.vue'),
      },
      // 流程设计-任务按钮
      {
        path: 'thirdEditOperation',
        name: 'thirdEditOperation',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/formEditOperation.vue'),
      },
      // 流程设计-任务表单权限
      {
        path: 'thirdSetOnlineFormAuth',
        name: 'thirdSetOnlineFormAuth',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/formSetOnlineFormAuth.vue'),
      },
      // 流程设计-添加变量
      {
        path: 'thirdFormEditFlowEntryVariable',
        name: 'thirdFormEditFlowEntryVariable',
        props: getProps,
        component: () => import('@/pages/workflow/flowEntry/formEditFlowEntryVariable.vue'),
      },
      // 流程设计- 新建状态
      {
        path: 'thirdFormEditFlowEntryStatus',
        name: 'thirdFormEditFlowEntryStatus',
        props: getProps,
        component: () => import('@/pages/workflow/flowEntry/formEditFlowEntryStatus.vue'),
      },
      // 流程设计- 任务提交
      {
        path: 'thirdTaskCommit',
        name: 'thirdTaskCommit',
        props: getProps,
        component: () => import('@/pages/workflow/components/TaskCommit.vue'),
      },
      // 自动化任务 - 编辑过滤条件
      {
        path: 'thirdEditTableFilter',
        name: 'thirdEditTableFilter',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/editSrcTableFilter.vue'),
      },
      // 自动化任务 - 编辑更新字段
      {
        path: 'thirdEditFieldUpdateData',
        name: 'thirdEditFieldUpdateData',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/editInsertData.vue'),
      },
      // 自动化任务 - 编辑响应字段
      {
        path: 'thirdEditResponseData',
        name: 'thirdEditResponseData',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/editResponseData.vue'),
      },
      // 自动化任务 - 编辑HTTP请求参数
      {
        path: 'thirdEditHttpRequestParam',
        name: 'thirdEditHttpRequestParam',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/editHttpParameter.vue'),
      },
      // 自动化任务 - 编辑HTTP请求头
      {
        path: 'thirdEditHttpHeader',
        name: 'thirdEditHttpHeader',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/editHttpHeader.vue'),
      },
      // 自动化任务 - 编辑聚合计算字段
      {
        path: 'thirdEditAggregationData',
        name: 'thirdEditAggregationData',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/editAggregationData.vue'),
      },
      // 自动化任务 - 编辑计算字段
      {
        path: 'thirdEditFormulaData',
        name: 'thirdEditFormulaData',
        props: getProps,
        component: () => import('@/pages/workflow/package/refactor/form/editFormulaData.vue'),
      },
      // 待办任务
      {
        path: 'thirdFormMyTask',
        name: 'thirdFormMyTask',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/formMyTask.vue'),
      },
      // 历史任务
      {
        path: 'thirdFormMyHistoryTask',
        name: 'thirdFormMyHistoryTask',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/formMyHistoryTask.vue'),
      },
      // 已办任务
      {
        path: 'thirdFormMyApprovedTask',
        name: 'thirdFormMyApprovedTask',
        props: getProps,
        component: () => import('@/pages/workflow/taskManager/formMyApprovedTask.vue'),
      },
      // 在线表单部分
      {
        path: 'thirdOnlineForm',
        name: 'thirdOnlineForm',
        props: getProps,
        component: () => import('@/pages/online/OnlinePageRender/index.vue'),
      },
      {
        path: 'thirdOnlineEditForm',
        name: 'thirdOnlineEditForm',
        props: getProps,
        component: () => import('@/pages/online/OnlinePageRender/OnlineEditForm/index.vue'),
      },
      {
        path: 'thirdFormOnlineDict',
        name: 'thirdFormOnlineDict',
        props: getProps,
        component: () => import('@/pages/online/formOnlineDict/index.vue'),
      },
      {
        path: 'thirdEditOnlineDict',
        name: 'thirdEditOnlineDict',
        props: getProps,
        component: () => import('@/pages/online/formOnlineDict/EditOnlineDict.vue'),
      },
      {
        path: 'thirdOnlinePage',
        name: 'thirdOnlinePage',
        props: getProps,
        component: () => import('@/pages/online/formOnlinePage/index.vue'),
      },
      {
        path: 'thirdEditOnlinePage',
        name: 'thirdEditOnlinePage',
        props: getProps,
        component: () => import('@/pages/online/editOnlinePage/index.vue'),
      },
      {
        path: 'thirdEditOnlineForm',
        name: 'thirdEditOnlineForm',
        props: getProps,
        component: () => import('@/pages/online/editOnlinePage/editOnlineForm.vue'),
      },
      {
        path: 'thirdEditPageDatasource',
        name: 'thirdEditPageDatasource',
        props: getProps,
        component: () => import('@/pages/online/editOnlinePage/editOnlinePageDatasource.vue'),
      },
      {
        path: 'thirdEditPageRelation',
        name: 'thirdEditPageRelation',
        props: getProps,
        component: () =>
          import('@/pages/online/editOnlinePage/editOnlinePageDatasourceRelation.vue'),
      },
      {
        path: 'thirdSetOnlineTableColumnRule',
        name: 'thirdSetOnlineTableColumnRule',
        props: getProps,
        component: () => import('@/pages/online/editOnlinePage/setOnlineTableColumnRule.vue'),
      },
      {
        path: 'thirdEditVirtualColumnFilter',
        name: 'thirdEditVirtualColumnFilter',
        props: getProps,
        component: () => import('@/pages/online/editOnlinePage/editVirtualColumnFilter.vue'),
      },
      {
        path: 'thirdEditTableColumn',
        name: 'thirdEditTableColumn',
        props: getProps,
        component: () => import('@/pages/online/editOnlinePage/formDesign/editTableColumn.vue'),
      },
      {
        path: 'thirdEditCustomFormOperate',
        name: 'thirdEditCustomFormOperate',
        props: getProps,
        component: () =>
          import('@/pages/online/editOnlinePage/formDesign/components/EditCustomFormOperate.vue'),
      },
      {
        path: 'thirdEditFormField',
        name: 'thirdEditFormField',
        props: getProps,
        component: () =>
          import('@/pages/online/editOnlinePage/formDesign/components/EditFormField.vue'),
      },
      {
        path: 'thirdEditDictParamValue',
        name: 'thirdEditDictParamValue',
        props: getProps,
        component: () =>
          import(
            '@/pages/online/editOnlinePage/formDesign/components/CustomWidgetDictSetting/EditDictParamValue.vue'
          ),
      },
      {
        path: 'thirdEditOnlineTableColumn',
        name: 'thirdEditOnlineTableColumn',
        props: getProps,
        component: () =>
          import(
            '@/pages/online/editOnlinePage/formDesign/components/OnlineTableColumnSetting/editOnlineTableColumn.vue'
          ),
      },
      {
        path: 'thirdEditOnlineTabPanel',
        name: 'thirdEditOnlineTabPanel',
        props: getProps,
        component: () =>
          import(
            '@/pages/online/editOnlinePage/formDesign/components/OnlineTabPanelSetting/editOnlineTabPanel.vue'
          ),
      },
      {
        path: 'thirdOnlineDblink',
        name: 'thirdOnlineDblink',
        props: getProps,
        component: () => import('@/pages/online/formOnlineDblink/index.vue'),
      },
      {
        path: 'thirdEditOnlineDblink',
        name: 'thirdEditOnlineDblink',
        props: getProps,
        component: () => import('@/pages/online/formOnlineDblink/editOnlineDblink.vue'),
      },
      // 打印部分
      {
        path: 'thirdPrint',
        name: 'thirdPrint',
        props: getProps,
        component: () => import('@/pages/report/formPrint/index.vue'),
      },
      {
        path: 'thirdEditPrintGroup',
        name: 'thirdEditPrintGroup',
        props: getProps,
        component: () => import('@/pages/report/formPrint/editPrintManageGroup.vue'),
      },
      {
        path: 'thirdPrintPreview',
        name: 'thirdPrintPreview',
        props: getProps,
        component: () => import('@/pages/report/formPrint/components/previewPrint.vue'),
      },
      {
        path: 'thirdPrintSpreadSheet',
        name: 'thirdPrintSpreadSheet',
        props: getProps,
        component: () => import('@/pages/report/formPrint/components/previewPrintSpreadSheet.vue'),
      },
      {
        path: 'thirdEditPrint',
        name: 'thirdEditPrint',
        props: getProps,
        component: () => import('@/pages/report/formPrint/editPrintTemplate.vue'),
      },
      // 设置数据集参数
      {
        path: 'thirdSetReportDatasetParam',
        name: 'thirdSetReportDatasetParam',
        props: getProps,
        component: () => import('@/pages/report/components/SetReportDatasetParam.vue'),
      },
      // 设置字段过滤
      {
        path: 'thirdEditReportColumnFilter',
        name: 'thirdEditReportColumnFilter',
        props: getProps,
        component: () =>
          import('@/pages/report/components/ReportColumnFilter/editReportColumnFilter.vue'),
      },
      // 设置字段排序
      {
        path: 'thirdEditReportColumnOrder',
        name: 'thirdEditReportColumnOrder',
        props: getProps,
        component: () =>
          import('@/pages/report/components/ReportColumnOrder/editReportColumnOrder.vue'),
      },
      // 数据集
      {
        path: 'thirdReportDataset',
        name: 'thirdReportDataset',
        props: getProps,
        component: () => import('@/pages/report/formReportDataset/index.vue'),
      },
      {
        path: 'thirdEditReportDataset',
        name: 'thirdEditReportDataset',
        props: getProps,
        component: () => import('@/pages/report/formReportDataset/editReportDataset.vue'),
      },
      {
        path: 'thirdEditReportDatasetGroup',
        name: 'thirdEditReportDatasetGroup',
        props: getProps,
        component: () => import('@/pages/report/formReportDataset/editReportDatasetGroup.vue'),
      },
      {
        path: 'thirdEditDatasetParam',
        name: 'thirdEditDatasetParam',
        props: getProps,
        component: () => import('@/pages/report/formReportDataset/components/editDatasetParam.vue'),
      },
      {
        path: 'thirdEditDatasetRelation',
        name: 'thirdEditDatasetRelation',
        props: getProps,
        component: () =>
          import('@/pages/report/formReportDataset/components/editReportRelation.vue'),
      },
      {
        path: 'thirdPrintEditTemplateWord',
        name: 'thirdPrintEditTemplateWord',
        props: getProps,
        component: () =>
          import('@/pages/report/formPrint/components/editTemplateWordDataset.vue')
      },
      {
        path: 'thirdPrintEditTemplateWordColumn',
        name: 'thirdPrintEditTemplateWordColumn',
        props: getProps,
        component: () =>
          import('@/pages/report/formPrint/components/editTemplateWordColumn.vue')
      },
      // 数据库链接
      {
        path: 'thirdReportDblink',
        name: 'thirdReportDblink',
        props: getProps,
        component: () => import('@/pages/report/formReportDblink/index.vue'),
      },
      {
        path: 'thirdEditReportDblink',
        name: 'thirdEditReportDblink',
        props: getProps,
        component: () => import('@/pages/report/formReportDblink/editReportDblink.vue'),
      },
      // 报表字典
      {
        path: 'thirdReportDict',
        name: 'thirdReportDict',
        props: getProps,
        component: () => import('@/pages/report/formReportDict/index.vue'),
      },
      {
        path: 'thirdEditReportDict',
        name: 'thirdEditReportDict',
        props: getProps,
        component: () => import('@/pages/report/formReportDict/editReportDict.vue'),
      },
      // 报表
      {
        path: 'thirdReportPage',
        name: 'thirdReportPage',
        props: getProps,
        component: () => import('@/pages/report/formReportPage/index.vue'),
      },
      {
        path: 'thirdEditReportPageGroup',
        name: 'thirdEditReportPageGroup',
        props: getProps,
        component: () => import('@/pages/report/formReportPage/editReportPageGroup.vue'),
      },
      {
        path: 'thirdEditReportPage',
        name: 'thirdEditReportPage',
        props: getProps,
        component: () => import('@/pages/report/formReportPage/editReportPage/index.vue'),
      },
      {
        path: 'thirdEditReportFormParam',
        name: 'thirdEditReportFormParam',
        props: getProps,
        component: () =>
          import(
            '@/pages/report/formReportPage/reportDesign/components/CustomFormSetting/editFormParam.vue'
          ),
      },
      {
        path: 'thirdEditReportFormOperate',
        name: 'thirdEditReportFormOperate',
        props: getProps,
        component: () =>
          import(
            '@/pages/report/formReportPage/reportDesign/components/CustomReportOperationSetting/editReportOperation.vue'
          ),
      },
      {
        path: 'thirdEditReportRouterOperate',
        name: 'thirdEditReportRouterOperate',
        props: getProps,
        component: () =>
          import(
            '@/pages/report/formReportPage/reportDesign/components/CustomReportOperationSetting/editRouteOperation.vue'
          ),
      },
      {
        path: 'thirdReport',
        name: 'thirdReport',
        props: getProps,
        component: () => import('@/pages/report/formReportPage/reportRender/index.vue'),
      },
      {
        path: 'thirdReportForm',
        name: 'thirdReportForm',
        props: getProps,
        component: () => import('@/pages/report/formReportPage/reportRender/ReportForm/index.vue'),
      },
      // 通用
      {
        path: 'thirdEditDictParamValue2',
        name: 'thirdEditDictParamValue2',
        props: getProps,
        component: () =>
          import(
            '@/online/components/WidgetAttributeSetting/components/CustomWidgetDictSetting/editDictParamValue.vue'
          ),
      },
      {
        path: 'thirdEditOnlineTableColumn2',
        name: 'thirdEditOnlineTableColumn2',
        props: getProps,
        component: () =>
          import(
            '@/online/components/WidgetAttributeSetting/components/OnlineTableColumnSetting/editOnlineTableColumn.vue'
          ),
      },
      {
        path: 'thirdEditOnlineTabPanel2',
        name: 'thirdEditOnlineTabPanel2',
        props: getProps,
        component: () =>
          import(
            '@/online/components/WidgetAttributeSetting/components/OnlineTabPanelSetting/editOnlineTabPanel.vue'
          ),
      },
      {
        path: 'thirdSelectDept',
        name: 'thirdSelectDept',
        props: getProps,
        component: () => import('@/components/DeptSelect/DeptSelectDlg.vue'),
      },
      {
        path: 'thirdSelectUser',
        name: 'thirdSelectUser',
        props: getProps,
        component: () => import('@/components/UserSelect/UserSelectDlg.vue'),
      },
      {
        path: 'thirdSelectData',
        name: 'thirdSelectData',
        props: getProps,
        component: () => import('@/online/components/OnlineCustomDataSelect/DataSelectDlg.vue'),
      },
      {
        path: 'thirdEditDataViewColumn',
        name: 'thirdEditDataViewColumn',
        props: getProps,
        component: () =>
          import(
            '@/online/components/WidgetAttributeSetting/components/ChartDatasetSetting/editDataViewTableColumn.vue'
          ),
      },
      {
        path: 'thirdEditWidgetColumnBind',
        name: 'thirdEditWidgetColumnBind',
        props: getProps,
        component: () =>
          import(
            '@/online/components/WidgetAttributeSetting/components/ChartDatasetSetting/editColumnBind.vue'
          ),
      },
      {
        path: 'thirdSetDatasetPaam',
        name: 'thirdSetDatasetPaam',
        props: getProps,
        component: () => import('@/online/components/SetReportDatasetParam/index.vue'),
      },
      {
        path: 'thirdEditWidgetCategroyColumn',
        name: 'thirdEditWidgetCategroyColumn',
        props: getProps,
        component: () =>
          import(
            '@/online/components/WidgetAttributeSetting/components/ChartDatasetSetting/editWidgetCategoryColumn.vue'
          ),
      },
      {
        path: 'thirdEditWidgetIndexColumn',
        name: 'thirdEditWidgetIndexColumn',
        props: getProps,
        component: () =>
          import(
            '@/online/components/WidgetAttributeSetting/components/ChartDatasetSetting/editWidgetIndexColumn.vue'
          ),
      },
      {
        path: 'thirdEditWidgetOrderInfo',
        name: 'thirdEditWidgetOrderInfo',
        props: getProps,
        component: () =>
          import(
            '@/online/components/WidgetAttributeSetting/components/ChartDatasetSetting/editWidgetOrderInfo.vue'
          ),
      },
      {
        path: 'thirdEditReportColumnFilter',
        name: 'thirdEditReportColumnFilter',
        props: getProps,
        component: () =>
          import(
            '@/online/components/WidgetAttributeSetting/components/ChartDatasetSetting/editReportColumnFilter.vue'
          ),
      },
      {
        path: 'thirdEditCustomEvent',
        name: 'thirdEditCustomEvent',
        props: getProps,
        component: () => import('@/online/components/CustomEventSetting/editCustomEvent.vue'),
      },
    ],
  },
];
